import { render, staticRenderFns } from "./c_bg_color.vue?vue&type=template&id=52dcd701&scoped=true"
import script from "./c_bg_color.vue?vue&type=script&lang=js"
export * from "./c_bg_color.vue?vue&type=script&lang=js"
import style0 from "./c_bg_color.vue?vue&type=style&index=0&id=52dcd701&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dcd701",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52dcd701')) {
      api.createRecord('52dcd701', component.options)
    } else {
      api.reload('52dcd701', component.options)
    }
    module.hot.accept("./c_bg_color.vue?vue&type=template&id=52dcd701&scoped=true", function () {
      api.rerender('52dcd701', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_bg_color.vue"
export default component.exports